import React from 'react';

export const Spinner = () =>
  (<p className="text-center"><i className="fa fa-spinner fa-spin" style={{ fontSize: '3em' }} /></p>);
